import {
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  ClipboardDocumentListIcon,
  DocumentTextIcon,
  MapIcon,
  NoSymbolIcon,
  PaperAirplaneIcon,
  PhoneIcon,
  PresentationChartLineIcon,
  TrophyIcon,
} from "@heroicons/react/24/outline";
import { FaTheaterMasks } from "react-icons/fa";
import { HiOutlineClipboardList } from "react-icons/hi";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { LiaTheaterMasksSolid } from "react-icons/lia";

/**
 * A practice module's icon, by the name stored on `Module.icon`. One map for
 * every surface that draws a module (the Practice grid, the home row, the
 * persona page's module list), so a module looks the same wherever it is
 * launched from. An unknown or missing name gets the paper plane.
 */
const MODULE_ICONS = {
  ChartBarIcon,
  ChatBubbleLeftRightIcon,
  ClipboardDocumentListIcon,
  ClipboardList: HiOutlineClipboardList,
  DocumentTextIcon,
  FaTheaterMasks,
  HiOutlineUserGroup,
  LiaTheaterMasksSolid,
  LightbulbIcon: PaperAirplaneIcon,
  MapIcon,
  NoSymbolIcon,
  PaperAirplaneIcon,
  PhoneIcon,
  PresentationChartLineIcon,
  TrophyIcon,
};

export function getModuleIcon(name) {
  return MODULE_ICONS[name] || PaperAirplaneIcon;
}
